import apiClient from './apiClient';

export const teamsApi = {
	// Get a team by ID
	getTeam: async (teamId) => {
		try {
			const response = await apiClient.get(`/api/teams/${teamId}`);
			return response.data;
		} catch (error) {
			console.error('Get team error:', error);
			throw new Error(
				error.response?.data?.message || 'Failed to fetch team'
			);
		}
	},

	// Create a new role
	createRole: async (teamId, roleData) => {
		try {
			const response = await apiClient.post(
				`/api/teams/${teamId}/roles`,
				roleData
			);
			return response.data;
		} catch (error) {
			console.error('Create role error:', error);
			throw new Error(
				error.response?.data?.message || 'Failed to create role'
			);
		}
	},

	// Delete a role
	deleteRole: async (teamId, roleId) => {
		try {
			const response = await apiClient.delete(
				`/api/teams/${teamId}/roles/${roleId}`
			);
			return response.data;
		} catch (error) {
			console.error('Delete role error:', error);
			throw new Error(
				error.response?.data?.message || 'Failed to delete role'
			);
		}
	},

	// Get team members
	getMembers: async (teamId) => {
		try {
			const response = await apiClient.get(`/api/teams/${teamId}/users`);
			return response.data;
		} catch (error) {
			console.error('Get team members error:', error);
			throw new Error(
				error.response?.data?.message || 'Failed to fetch team members'
			);
		}
	},

	// Add members to team
	addMembers: async (teamId, userIds) => {
		try {
			const response = await apiClient.post(
				`/api/teams/${teamId}/users`,
				{ userIds }
			);
			return response.data;
		} catch (error) {
			console.error('Add team members error:', error);
			throw new Error(
				error.response?.data?.message || 'Failed to add team members'
			);
		}
	},

	// Remove member from team
	removeMember: async (teamId, userId) => {
		try {
			const response = await apiClient.delete(
				`/api/teams/${teamId}/users/${userId}`
			);
			return response.data;
		} catch (error) {
			console.error('Remove team member error:', error);
			throw new Error(
				error.response?.data?.message || 'Failed to remove team member'
			);
		}
	},
};
